// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__219Qn","header":"ClearentDisclaimer_header__QIY8S","inner":"ClearentDisclaimer_inner__fx7tE"};